// extracted by mini-css-extract-plugin
export default {"tariffCard":"tariff-page_tariffCard__iACxg"};